import { AirflowView } from './airflow';

export function AirflowScreen() {
  return (
    <div className="h-full w-full overflow-y-auto p-4 md:p-6">
      <AirflowView />
    </div>
  );
}
